import {
  FETCH_CNC_MANUAL_WEBORDER_STATUS,
  FETCH_CNC_MANUAL_WEBORDER_STATUS_SUCCESS,
  FETCH_CNC_MANUAL_WEBORDER_STATUS_FAILURE,
  RESET_CNC_MANUAL_WEBORDER_STATUS,
  MODIFY_CNC_MANUAL_WEBORDER_STATUS,
  MODIFY_CNC_MANUAL_WEBORDER_STATUS_SUCCESS,
  MODIFY_CNC_MANUAL_WEBORDER_STATUS_FAILURE,
  SET_CNC_SCANNED_DATA,
  FETCH_CNC_SCANNED_WEBORDER_STATUS,
  FETCH_CNC_SCANNED_WEBORDER_STATUS_SUCCESS,
  FETCH_CNC_SCANNED_WEBORDER_STATUS_FAILURE,
  RESET_CNC_SCANNED_WEBORDER_STATUS,
  MODIFY_CNC_SCANNED_WEBORDER_STATUS,
  MODIFY_CNC_SCANNED_WEBORDER_STATUS_SUCCESS,
  MODIFY_CNC_SCANNED_WEBORDER_STATUS_FAILURE,
} from "./cncWebOrderTypes";

export const fetchCNCManualWeborderStatus = ({ weborderNo }) => ({
  type: FETCH_CNC_MANUAL_WEBORDER_STATUS,
  payload: { weborderNo },
});

export const fetchCNCManualWeborderStatusSuccess = ({
  woStatus,
  woId,
  woNo,
  pickup_store_location,
}) => ({
  type: FETCH_CNC_MANUAL_WEBORDER_STATUS_SUCCESS,
  payload: {
    woStatus,
    woId,
    woNo,
    pickup_store_location,
  },
});

export const fetchCNCManualWeborderStatusFailure = ({ error }) => ({
  type: FETCH_CNC_MANUAL_WEBORDER_STATUS_FAILURE,
  payload: { error },
});

export const resetCNCManualWeborderStatus = () => ({
  type: RESET_CNC_MANUAL_WEBORDER_STATUS,
});

export const modifyCNCManualWeborderStatus = ({
  woId,
  woNo,
  woStatus,
  customerEntry,
}) => ({
  type: MODIFY_CNC_MANUAL_WEBORDER_STATUS,
  payload: { woId, woNo, woStatus, customerEntry },
});

export const modifyCNCManualWeborderStatusSuccess = ({
  woId,
  woNo,
  woStatus,
  customerEntry,
}) => ({
  type: MODIFY_CNC_MANUAL_WEBORDER_STATUS_SUCCESS,
  payload: { woId, woNo, woStatus, customerEntry },
});

export const modifyCNCManualWeborderStatusFailure = ({ error }) => ({
  type: MODIFY_CNC_MANUAL_WEBORDER_STATUS_FAILURE,
  payload: { error },
});

export const setCNCScannedData = ({ text }) => ({
  type: SET_CNC_SCANNED_DATA,
  payload: { text },
});

export const fetchCNCScannedWeborderStatus = ({ weborderNo }) => ({
  type: FETCH_CNC_SCANNED_WEBORDER_STATUS,
  payload: { weborderNo },
});

export const fetchCNCScannedWeborderStatusSuccess = ({
  woStatus,
  woId,
  woNo,
  pickup_store_location,
}) => ({
  type: FETCH_CNC_SCANNED_WEBORDER_STATUS_SUCCESS,
  payload: {
    woStatus,
    woId,
    woNo,
    pickup_store_location,
  },
});

export const fetchCNCScannedWeborderStatusFailure = ({ error }) => ({
  type: FETCH_CNC_SCANNED_WEBORDER_STATUS_FAILURE,
  payload: { error },
});

export const resetCNCScannedWeborderStatus = () => ({
  type: RESET_CNC_SCANNED_WEBORDER_STATUS,
});

export const modifyCNCScannedWeborderStatus = ({
  woId,
  woNo,
  woStatus,
  customerEntry,
}) => ({
  type: MODIFY_CNC_SCANNED_WEBORDER_STATUS,
  payload: { woId, woNo, woStatus, customerEntry },
});

export const modifyCNCScannedWeborderStatusSuccess = ({
  woId,
  woNo,
  woStatus,
  customerEntry,
}) => ({
  type: MODIFY_CNC_SCANNED_WEBORDER_STATUS_SUCCESS,
  payload: { woId, woNo, woStatus, customerEntry },
});

export const modifyCNCScannedWeborderStatusFailure = ({ error }) => ({
  type: MODIFY_CNC_SCANNED_WEBORDER_STATUS_FAILURE,
  payload: { error },
});
